<template>
  <div>
    <EN v-if="$i18n.locale === 'en'"></EN>
    <CN v-if="$i18n.locale === 'zh'"></CN>
  </div>
</template>

<script>
import EN from "./EN.vue";
import CN from "./CN.vue";
export default {
  name: "T-F-Under-Grad-2026",
  components: { EN, CN },
};
</script>

<style scoped></style>
